module.exports = __webpack_public_path__ + "img/congratulations-box-bg.8f40e6c6.png";